import { parseDate, parseRangeToDate } from '@/helpers/date';
import Dte from '@/models/respuestas/dte.model';
import { TiposFiltrosDocumentos } from '@/redux/slices/dteSlice/dteSlice';
import { RangoSerializable } from '@/models/componentes/datePicker.model';
import { comprobarInclusion, separarNumerosYPalabras } from '@/helpers/textos';
import { isMatch } from 'react-day-picker';

export const fechaEsValida = (dte: Dte, rango: RangoSerializable): boolean => {
  const fechaDocumento = parseDate(dte.feDocumento);
  const { from, to } = parseRangeToDate(rango);

  if (!isMatch(fechaDocumento, [{ before: from, after: to }])) {
    return true;
  }
  return false;
};

export const folioEsValido = (dte: Dte, query: string): boolean => {
  if (query.length === 0) return true;

  const { numeros, palabras } = separarNumerosYPalabras(query);

  if (
    comprobarInclusion(dte.folio.toString(), numeros) &&
    comprobarInclusion(dte.noTipoDoc.toLowerCase(), palabras)
  ) {
    return true;
  }

  return false;
};

export const deudorEsValido = (dte: Dte, rut: string): boolean => {
  if (!rut || rut === 'Todos los deudores') return true;
  if (dte.rutReceptor === rut) {
    return true;
  }

  return false;
};

export const filtrarFacturas = (
  dtes: Dte[],
  filtros: TiposFiltrosDocumentos
) => {
  const resultado = dtes.filter(
    (d) =>
      folioEsValido(d, filtros.folio) &&
      deudorEsValido(d, filtros.deudor.rut) &&
      fechaEsValida(d, filtros.emision)
  );

  return resultado;
};
